export default __webpack_public_path__ + "src/images/galleries/2/sidebar_bg-ce0bc7.png";